import {
  Component,
  OnInit,
  ViewChild,
  ChangeDetectionStrategy,
  OnDestroy,
  Input,
  ChangeDetectorRef,
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { PatientDevice, PatientsService } from 'src/app/core/lists';
import { MatTableDataSource } from '@angular/material/table';
import { FormService } from 'src/app/core/events';
import { PatientDeviceViewDialogComponent } from '../patient-device-view/patient-device-view.dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { AssignDeviceComponent } from '../assign-device/assign-device.component';
import { LayoutUtilsService, MessageType } from '../../../../../../../../core/_base/crud';
import { ActivatedRoute } from '@angular/router';
@Component({
  // tslint:disable-next-line:component-selector
  selector: 'kt-patient-devices-list',
  templateUrl: './patient-devices-list.component.html',
  styleUrls: ['./patient-devices-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PatientDevicesListComponent implements OnInit, OnDestroy {
  @Input() patientDevices$: Observable<Array<PatientDevice>>;
  displayedColumns: string[] = [
    'name',
    'serial_id',
    'date_last_sync',
    'last_battery_value',
    'alerts',
    'view',
  ];
  dataSource: MatTableDataSource<PatientDevice>;
  inputSubscription: Subscription;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @Input() patientId: any;
  hasDeviceAlerts: boolean;
  patientDevicesarr$ = new BehaviorSubject([]);
  isReadOnly = false;
  loading = true;

  constructor(
    public dialog: MatDialog,
    private formService: FormService,
    private layoutUtilsService: LayoutUtilsService,
    private patientsService: PatientsService,
    private activatedRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.inputSubscription = this.patientDevicesarr$.subscribe((res) => {
      if (!res) {
        return;
      }
      this.dataSource = new MatTableDataSource(res);
      this.dataSource.paginator = this.paginator;
    });
    if (
      this.activatedRoute.url[`_value`][1] &&
      this.activatedRoute.url[`_value`][1].path === 'view'
    ) {
      this.isReadOnly = true;
      this.cdr.detectChanges();
    }
    setTimeout(() => {
      if (this.patientId) this.getPatientDevices();
      this.loading = false;
    }, 2000);
  }

  ngOnDestroy() {
    this.inputSubscription.unsubscribe();
  }

  getPatientDevices() {
    this.patientsService.getPatientDevices(this.patientId?.id).subscribe((res) => {
      this.patientDevicesarr$.next(res);
      this.hasDeviceAlerts = this.hasAlerts(res);
    });
  }

  hasAlerts(patientDevices) {
    for (const device of patientDevices) {
      if (device.alerts.length > 0) {
        return true;
      }
    }
    return false;
  }

  patientDeviceHasAlerts(alerts) {
    return alerts.length > 0;
  }

  getAlertsString(alerts) {
    let alertString = '';
    for (const alert of alerts) {
      alertString = alertString.concat(alert.typeAlert + '\n');
    }
    return alertString.slice(0, -1);
  }

  viewPatientDevice(patientDevice: PatientDevice) {
    this.formService.getForm(patientDevice.form_id).subscribe((res) => {
      this.dialog.open(PatientDeviceViewDialogComponent, {
        data: { patientDevice, form: res.data.schema },
        width: '60vw',
      });
    });
  }

  assignDevice(device?: any) {
    const message = 'Device assigned successful';
    const dialogRef = this.dialog.open(AssignDeviceComponent, {
      disableClose: true,
      data: {
        model: device,
        patientId: this.patientId,
      },
      width: '400px',
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (!res.reload) {
        return;
      }
      this.ngOnInit();
      this.layoutUtilsService.showActionNotification(
        message,
        MessageType.Update,
        3000,
        false,
        false,
      );
    });
  }
}
